import { GlobalWidgetConfiguration } from "./GlobalWidgetConfiguration";
export function setupPlatform() {
    var globalWidgetConfiguration = new GlobalWidgetConfiguration(HTMLElement !== undefined &&
        HTMLElement.prototype !== undefined &&
        HTMLElement.prototype.attachShadow !== undefined);
    // HACK: provide an escape hatch to fully reset the global configuration
    // This probably needs to be removed at some point... but is for now useful in
    // some test scenarios
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    globalWidgetConfiguration.__dangerousResetSGWTWidgetConfiguration__ = setupPlatform;
    var currentGlobalWidgetConfiguration = window.SGWTWidgetConfiguration;
    Object.defineProperty(window, "SGWTWidgetConfiguration", {
        get: function () { return globalWidgetConfiguration; },
        set: function (x) {
            globalWidgetConfiguration.update(x);
        },
        configurable: true,
    });
    if (currentGlobalWidgetConfiguration != undefined) {
        window.SGWTWidgetConfiguration.update(currentGlobalWidgetConfiguration);
    }
}
